/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_ProInputs */

const en_fw_pub_pro = /** @type {(inputs: Fw_Pub_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing templates is a Pro feature.`)
};

const id_fw_pub_pro = /** @type {(inputs: Fw_Pub_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menerbitkan template adalah fitur Pro.`)
};

/**
* | output |
* | --- |
* | "Publishing templates is a Pro feature." |
*
* @param {Fw_Pub_ProInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_pro = /** @type {((inputs?: Fw_Pub_ProInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_ProInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_pro(inputs)
	return en_fw_pub_pro(inputs)
});